var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 30,
    viewBox: "0 0 13 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1027",
    "data-name": "Grupo 1027",
    transform: "translate(-392 -458)"
  }, /*#__PURE__*/React.createElement("rect", {
    color: "#CCC",
    id: "Ret\\xE2ngulo_1438",
    "data-name": "Ret\\xE2ngulo 1438",
    width: 5,
    height: 5,
    rx: 2.5,
    transform: "translate(392 458)"
  }), /*#__PURE__*/React.createElement("rect", {
    color: "#CCC",
    id: "Ret\\xE2ngulo_1435",
    "data-name": "Ret\\xE2ngulo 1435",
    width: 5,
    height: 5,
    rx: 2.5,
    transform: "translate(392 474)"
  }), /*#__PURE__*/React.createElement("rect", {
    color: "#CCC",
    id: "Ret\\xE2ngulo_1436",
    "data-name": "Ret\\xE2ngulo 1436",
    width: 5,
    height: 5,
    rx: 2.5,
    transform: "translate(392 466)"
  }), /*#__PURE__*/React.createElement("rect", {
    color: "#CCC",
    id: "Ret\\xE2ngulo_1437",
    "data-name": "Ret\\xE2ngulo 1437",
    width: 5,
    height: 5,
    rx: 2.5,
    transform: "translate(392 483)"
  }), /*#__PURE__*/React.createElement("rect", {
    color: "#CCC",
    id: "Ret\\xE2ngulo_1439",
    "data-name": "Ret\\xE2ngulo 1439",
    width: 5,
    height: 5,
    rx: 2.5,
    transform: "translate(400 458)"
  }), /*#__PURE__*/React.createElement("rect", {
    color: "#CCC",
    id: "Ret\\xE2ngulo_1432",
    "data-name": "Ret\\xE2ngulo 1432",
    width: 5,
    height: 5,
    rx: 2.5,
    transform: "translate(400 474)"
  }), /*#__PURE__*/React.createElement("rect", {
    color: "#CCC",
    id: "Ret\\xE2ngulo_1434",
    "data-name": "Ret\\xE2ngulo 1434",
    width: 5,
    height: 5,
    rx: 2.5,
    transform: "translate(400 466)"
  }), /*#__PURE__*/React.createElement("rect", {
    color: "#CCC",
    id: "Ret\\xE2ngulo_1433",
    "data-name": "Ret\\xE2ngulo 1433",
    width: 5,
    height: 5,
    rx: 2.5,
    transform: "translate(400 483)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/dragIcon.3c87925abcbacbff283d69f9fe6768da.svg";
export { ForwardRef as ReactComponent };